import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parseQueryString } from "@saleor/utils/urls";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  ProductTypeListUrlQueryParams,
  ProductTypeListUrlSortField,
  ProductTypeUrlQueryParams
} from "./urls";
import ProductTypeCreate from "./views/ProductTypeCreate";
import ProductTypeListComponent from "./views/ProductTypeList";
import ProductTypeUpdateComponent from "./views/ProductTypeUpdate";

const ProductTypeList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(
    qs,
    ProductTypeListUrlSortField
  ) as ProductTypeListUrlQueryParams;
  return <ProductTypeListComponent params={params} />;
};

const ProductTypeUpdate: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQueryString<ProductTypeUrlQueryParams>(
    location.search.substr(1)
  );

  return (
    <ProductTypeUpdateComponent id={decodeURIComponent(id)} params={params} />
  );
};

export const ProductTypeRouter: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.productTypes)} />
      <Routes>
        <Route path={""} element={<ProductTypeList />} />
        <Route path={"add"} element={<ProductTypeCreate />} />
        <Route path={":id"} element={<ProductTypeUpdate />} />
      </Routes>
    </>
  );
};
ProductTypeRouter.displayName = "ProductTypeRouter";
export default ProductTypeRouter;
